import { ARROW_BUTTON } from "@/src/lib/SmartDB/Commons/Constants/images";
import { MyLink } from '@/src/components/AppComponents/MyLink/MyLInk';
import React, { useState } from 'react';
import styles from './Button.module.scss';
import classNames from "classnames";

type HtmlButtonProps = React.ButtonHTMLAttributes<HTMLButtonElement> & {
    href?: undefined;
};

type AnchorProps = React.AnchorHTMLAttributes<HTMLAnchorElement> & {
    href: string;
};

interface ButtonProps {
    className?: string;
    mode?:
        | 'outline'
        | 'outline-error'
        | 'outline-no-arrow'
        | 'outline-no-arrow-disabled-transparent'
        | 'outline-loading'
        | 'outline-sqr'
        | 'filled'
        | 'filled-no-arrow'
        | 'action-arrow'
        | 'link-arrow'
        | 'action'
        | 'link'
        | 'link2'
        | 'connect';
    size?: 'very-small' | 'small' | 'medium' | 'large' | 'very-large';
    width?: number | string;
    arrow?: boolean;
    error?: boolean;
    disabled?: boolean;
    active?: boolean;
    children: React.ReactNode;
    onClick?: (event?: React.MouseEvent<HTMLButtonElement>) => void;
}

interface Overload {
    (props: HtmlButtonProps & ButtonProps): JSX.Element;
    (props: AnchorProps & ButtonProps): JSX.Element;
}

const hasHref = (props: HtmlButtonProps | AnchorProps): props is AnchorProps => 'href' in props;

export const Button: Overload = ({ mode = 'outline', size = 'medium', arrow, active = false, error, className, ...props }: ButtonProps) => {
    const isWithArrow = arrow === true || (arrow === undefined && mode !== 'action' && mode !== 'link' && mode.includes('arrow') && !mode.includes('no-arrow'));
    const isWithError = error === true || (error === undefined && mode.includes('error'));

    const componentProps = {
        className: classNames(
            styles.btn,
            styles[`btn--${size}`],
            styles[`btn--${mode}`],
            active === true ? styles.active : '',
            isWithError === true ? styles.error : '',
            className
        ),
        ...props,
    };

    const [onHover, setIsHover] = useState(false);

    if (hasHref(componentProps)) {
        return (
            <MyLink
                {...componentProps}
                style={componentProps.width ? { width: componentProps.width } : {}}
                onMouseEnter={() => {
                    setIsHover(true);
                }}
                onMouseLeave={() => {
                    setIsHover(false);
                }}
            >
                {componentProps.children}
                {isWithArrow === true && (
                    <div className={styles.iconBtn}>
                        {onHover ? (
                            <>
                                <svg className={styles.icon}>
                                    <use href={ARROW_BUTTON}></use>
                                </svg>
                            </>
                        ) : (
                            <>
                                <svg className={styles.icon}>
                                    <use href={ARROW_BUTTON}></use>
                                </svg>
                            </>
                        )}
                    </div>
                )}
            </MyLink>
        );
    }

    return (
        <button
            {...componentProps}
            style={componentProps.width ? { width: componentProps.width } : {}}
            onMouseEnter={() => {
                setIsHover(true);
            }}
            onMouseLeave={() => {
                setIsHover(false);
            }}
        >
            {componentProps.children}
            {isWithArrow === true && (
                <div className={styles.iconBtn}>
                    {onHover ? (
                        <>
                            <svg className={styles.icon}>
                                <use href={ARROW_BUTTON}></use>
                            </svg>
                        </>
                    ) : (
                        <>
                            <svg className={styles.icon}>
                                <use href={ARROW_BUTTON}></use>
                            </svg>
                        </>
                    )}
                </div>
            )}
        </button>
    );
};
